import { createContext, useContext, useEffect, useState } from "react";
import { Theme } from "../themes/theme";

const MobileContext = createContext(null);

const BREAKPOINT = Theme.breakpoints.TABLET_LARGE;

export function MobileProvider({ children }) {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= BREAKPOINT,
  );

  useEffect(() => {
    const handler = () => {
      setIsMobile(window.innerWidth <= BREAKPOINT);
    };

    window.addEventListener("resize", handler);

    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <MobileContext.Provider value={{ isMobile }}>
      {children}
    </MobileContext.Provider>
  );
}

export function useMobile() {
  const ctx = useContext(MobileContext);

  if (!ctx) {
    throw new Error("useMobile must be used within MobileProvider");
  }

  return ctx;
}
